import React from 'react';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { TextInput } from 'playup-web-core';

import LoadingButton from '../../../../components/LoadingButton';
import useNotify from '../../../../hooks/useNotify';
import { createExternalDeposit } from '../../../../api/deposit';
import { parseApiError } from '../../../../utils/parseApiError';

const Bpay: React.FC<Props> = ({ amount, bpayDetails, selectedPromotion }) => {
	const [sending, setSending] = React.useState<boolean>(false);
	const [errors, setErrors] = React.useState<APIError>();
	const { register, handleSubmit } = useForm<FormData>({
		defaultValues: {
			date: dayjs().format('YYYY-MM-DD'),
		},
	});
	const [success, setSuccess] = React.useState<boolean>(false);

	const notify = useNotify();

	const onSubmit = (data: FormData) => {
		createExternalDeposit({
			date: dayjs(data.date).format('YYYY-MM-DD'),
			amount,
			deposit_request_type: 'BPAY',
			promotion: selectedPromotion,
		})
			.then(() => {
				setSuccess(true);
				notify({
					type: 'success',
					title: 'Success',
					message: 'Your Deposit Notice has been received.',
					timeout: 5000,
				});
			})
			.catch((error) => {
				setErrors(error.errors);
				setSuccess(false);
			})
			.finally(() => {
				setSending(false);
			});
	};

	return (
		<div className="_px-4 _text-black _mt-2">
			<p className="_text-sm">Use this feature to advise us that you have already deposited money using BPay.</p>
			<p className="_pt-2 _font-bold">BPAY Details</p>
			<div className="_flex _flex-col _py-2">
				<div>
					<span className="_font-semibold">Biller Code: </span>
					{bpayDetails?.biller_code || 'n/a'}
				</div>
				<div>
					<span className="_font-semibold">Reference: </span>
					{bpayDetails?.user_reference || 'n/a'}
				</div>
			</div>
			<p className="_pt-2 _font-bold">Telephone & Internet Banking</p>
			<p className="_pt-2">
				BPay Call your bank, credit union or building society to make this payment from your cheque, savings or credit
				card account.
			</p>
			<p className="_pt-1">
				More info:
				<a href="http://www.bpay.com.au">www.bpay.com.au</a>
			</p>
			<div className="_mt-4 _border-t _border-gray-200" />
			<div>
				<form onSubmit={handleSubmit(onSubmit)} className="_px-2 _pb-4">
					<TextInput
						type="date"
						label="Deposit Date"
						error={parseApiError(errors, 'date')}
						className="_mt-4"
						{...register('date', { required: true })}
						kind="white"
					/>
					<div className="_flex _items-center _justify-end md:_px-8">
						<LoadingButton type="submit" loading={sending} className="_w-full _mt-4 _btn _btn-primary _rounded">
							Deposit
						</LoadingButton>
					</div>
					{errors && errors.error && <p className="_text-center _text-red-700">{errors.error}</p>}
					{success && <p className="_text-center _text-green-500">Your Deposit Notice has been received</p>}
				</form>
			</div>
		</div>
	);
};

export default Bpay;

interface Props {
	amount: number;
	bpayDetails?: {
		biller_code: string;
		user_reference: string;
	};
	selectedPromotion?: {
		id: string;
		client_id: number;
	};
}

interface FormData {
	date: string;
}
